/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



(function() {
  
  if (window.location.pathname === '/collections/suncare/products/tinted-sun-cream-spf30-50ml') {
  window.location.href = '/products/tinted-sun-cream-spf30-50ml';
  }
  if (window.location.pathname === '/collections/suncare/products/sun-protection-bi-phase-water-spf30-150ml') {
      window.location.href = '/products/sun-protection-bi-phase-water-spf30-150ml';
  }
  if (window.location.pathname === '/collections/suncare/products/sun-glow-shimmering-face-body-lotion-100ml') {
      window.location.href = '/products/sun-glow-shimmering-face-body-lotion-100ml';
  }
  if (window.location.pathname === '/collections/must-haves/products/vertigo-eau-de-parfum-100ml') {
      window.location.href = '/products/vertigo-eau-de-parfum-100ml';
  }
  if (window.location.pathname === '/collections/perfume/products/vertigo-eau-de-parfum-100ml') {
      window.location.href = '/products/vertigo-eau-de-parfum-100ml';
  }
  if (window.location.pathname === '/collections/best-sellers/products/shampoo-new-technology-300ml') {
      window.location.href = '/products/shampoo-new-technology-300ml';
  }
  if (window.location.pathname === '/collections/new-arrivals/products/shampoo-new-technology-300ml') {
      window.location.href = '/products/shampoo-new-technology-300ml';
  }
  if (window.location.pathname === '/collections/haircare/products/shampoo-new-technology-300ml') {
      window.location.href = '/products/shampoo-new-technology-300ml';
  }
  if (window.location.pathname === '/collections/hot-offers/products/imera-tis-gynaikas') {
      window.location.href = '/products/imera-tis-gynaikas';
  }
  if (window.location.pathname === '/collections/must-haves/products/hair-oil-150ml') {
      window.location.href = '/products/hair-oil-150ml';
  }
  if (window.location.pathname === '/collections/new-arrivals/products/hair-oil-150ml') {
      window.location.href = '/products/hair-oil-150ml';
  }
  if (window.location.pathname === '/collections/haircare/products/hair-oil-150ml') {
      window.location.href = '/products/hair-oil-150ml';
  }
  if (window.location.pathname === '/collections/must-haves/products/instant-spray-280ml') {
      window.location.href = '/products/instant-spray-280ml';
  }
  if (window.location.pathname === '/collections/new-arrivals/products/instant-spray-280ml') {
      window.location.href = '/products/instant-spray-280ml';
  }
  if (window.location.pathname === '/collections/haircare/products/instant-spray-280ml') {
      window.location.href = '/products/instant-spray-280ml';
  }
  if (window.location.pathname === '/collections/new-arrivals/products/hair-mask-300ml') {
      window.location.href = '/products/hair-mask-300ml';
  }
  if (window.location.pathname === '/collections/haircare/products/hair-mask-300ml') {
      window.location.href = '/products/hair-mask-300ml';
  }
  if (window.location.pathname === '/collections/makeup/products/lash-therapy') {
      window.location.href = '/products/lash-therapy';
  }
  if (window.location.pathname === '/collections/best-sellers/products/ouaou-mascara') {
      window.location.href = '/products/ouaou-mascara';
  }
  if (window.location.pathname === '/collections/makeup/products/ouaou-mascara') {
      window.location.href = '/products/ouaou-mascara';
  }
  if (window.location.pathname === '/collections/must-haves/products/concealer-n1-light-to-medium') {
      window.location.href = '/products/concealer-n1-light-to-medium';
  }
  if (window.location.pathname === '/collections/makeup/products/concealer-n1-light-to-medium') {
      window.location.href = '/products/concealer-n1-light-to-medium';
  }
  if (window.location.pathname === '/collections/must-haves/products/concealer-n2-medium-to-dark') {
      window.location.href = '/products/concealer-n2-medium-to-dark';
  }
  if (window.location.pathname === '/collections/makeup/products/concealer-n2-medium-to-dark') {
      window.location.href = '/products/concealer-n2-medium-to-dark';
  }
  if (window.location.pathname === '/collections/best-sellers/products/silk-skin-foundation-n1-light') {
      window.location.href = '/products/silk-skin-foundation-n1-light';
  }
  if (window.location.pathname === '/collections/must-haves/products/silk-skin-foundation-n1-light') {
      window.location.href = '/products/silk-skin-foundation-n1-light';
  }
  if (window.location.pathname === '/collections/makeup/products/silk-skin-foundation-n1-light') {
      window.location.href = '/products/silk-skin-foundation-n1-light';
  }
  if (window.location.pathname === '/collections/best-sellers/products/silk-skin-foundation-n2-medium') {
      window.location.href = '/products/silk-skin-foundation-n2-medium';
  }
  if (window.location.pathname === '/collections/must-haves/products/silk-skin-foundation-n2-medium') {
      window.location.href = '/products/silk-skin-foundation-n2-medium';
  }
  if (window.location.pathname === '/collections/makeup/products/silk-skin-foundation-n2-medium') {
      window.location.href = '/products/silk-skin-foundation-n2-medium';
  }
  if (window.location.pathname === '/collections/best-sellers/products/silk-skin-foundation-n3-dark') {
      window.location.href = '/products/silk-skin-foundation-n3-dark';
  }
  if (window.location.pathname === '/collections/must-haves/products/silk-skin-foundation-n3-dark') {
      window.location.href = '/products/silk-skin-foundation-n3-dark';
  }
  if (window.location.pathname === '/collections/makeup/products/silk-skin-foundation-n3-dark') {
      window.location.href = '/products/silk-skin-foundation-n3-dark';
  }
  if (window.location.pathname === '/collections/makeup/products/space-vibes-palette-n2') {
      window.location.href = '/products/space-vibes-palette-n2';
  }
  if (window.location.pathname === '/collections/must-haves/products/terra-vibes-palette-n1') {
      window.location.href = '/products/terra-vibes-palette-n1';
  }
  if (window.location.pathname === '/collections/makeup/products/terra-vibes-palette-n1') {
      window.location.href = '/products/terra-vibes-palette-n1';
  }
  if (window.location.pathname === '/collections/makeup/products/transparent-loose-powder') {
      window.location.href = '/products/transparent-loose-powder';
  }
  if (window.location.pathname === '/collections/best-sellers/products/lipstick-n01-fire') {
      window.location.href = '/products/lipstick-n01-fire';
  }
  if (window.location.pathname === '/collections/makeup/products/lipstick-n01-fire') {
      window.location.href = '/products/lipstick-n01-fire';
  }
  if (window.location.pathname === '/collections/must-haves/products/lipstick-n02-neutral') {
      window.location.href = '/products/lipstick-n02-neutral';
  }
  if (window.location.pathname === '/collections/makeup/products/lipstick-n02-neutral') {
      window.location.href = '/products/lipstick-n02-neutral';
  }
  if (window.location.pathname === '/collections/makeup/products/lipstick-n03-annita') {
      window.location.href = '/products/lipstick-n03-annita';
  }
  if (window.location.pathname === '/collections/makeup/products/lipstick-n04-pink-it') {
      window.location.href = '/products/lipstick-n04-pink-it';
  }
  if (window.location.pathname === '/collections/makeup/products/lipstick-n05-mama') {
      window.location.href = '/products/lipstick-n05-mama';
  }
  if (window.location.pathname === '/collections/makeup/products/lipstick-n06-penny') {
      window.location.href = '/products/lipstick-n06-penny';
  }
  if (window.location.pathname === '/collections/makeup/products/colored-lip-volume') {
      window.location.href = '/products/colored-lip-volume';
  }
  if (window.location.pathname === '/collections/must-haves/products/black-diamond-cleanser-200ml') {
      window.location.href = '/products/black-diamond-cleanser-200ml';
  }
  if (window.location.pathname === '/collections/skincare/products/black-diamond-cleanser-200ml') {
      window.location.href = '/products/black-diamond-cleanser-200ml';
  }
  if (window.location.pathname === '/collections/new-arrivals/products/la-creme-24h-age-control-50ml') {
      window.location.href = '/products/la-creme-24h-age-control-50ml';
  }
  if (window.location.pathname === '/collections/skincare/products/la-creme-24h-age-control-50ml') {
      window.location.href = '/products/la-creme-24h-age-control-50ml';
  }
  if (window.location.pathname === '/collections/skincare/products/face-serum-30ml') {
      window.location.href = '/products/face-serum-30ml';
  }
  if (window.location.pathname === '/collections/best-sellers/products/face-mask-50ml') {
      window.location.href = '/products/face-mask-50ml';
  }
  if (window.location.pathname === '/collections/skincare/products/face-mask-50ml') {
      window.location.href = '/products/face-mask-50ml';
  }
  if (window.location.pathname === '/collections/skincare/products/eye-cream-20ml') {
      window.location.href = '/products/eye-cream-20ml';
  }

  if (window.location.pathname === '/collections/all-products/products/black-diamond-cleanser-doro-ouaou-mascara') {
    window.location.href = '/products/black-diamond-cleanser-doro-ouaou-mascara';
  }
  
  if (window.location.pathname === '/collections/all-products/products/black-diamond-cleanser-200ml') {
      window.location.href = '/products/black-diamond-cleanser-200ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/colored-lip-volume') {
      window.location.href = '/products/colored-lip-volume';
  }
  
  if (window.location.pathname === '/collections/all-products/products/concealer-n1-light-to-medium') {
      window.location.href = '/products/concealer-n1-light-to-medium';
  }
  
  if (window.location.pathname === '/collections/all-products/products/concealer-n2-medium-to-dark') {
      window.location.href = '/products/concealer-n2-medium-to-dark';
  }
  
  if (window.location.pathname === '/collections/all-products/products/eye-cream-20ml') {
      window.location.href = '/products/eye-cream-20ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/face-mask-50ml') {
      window.location.href = '/products/face-mask-50ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/face-serum-30ml') {
      window.location.href = '/products/face-serum-30ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/hair-mask-300ml') {
      window.location.href = '/products/hair-mask-300ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/hair-oil-150ml') {
      window.location.href = '/products/hair-oil-150ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/instant-spray-280ml') {
      window.location.href = '/products/instant-spray-280ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/la-creme-24h-age-control-50ml') {
      window.location.href = '/products/la-creme-24h-age-control-50ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lash-therapy') {
      window.location.href = '/products/lash-therapy';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lipstick-n-01') {
      window.location.href = '/products/lipstick-n-01';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lipstick-n02-neutral') {
      window.location.href = '/products/lipstick-n02-neutral';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lipstick-n03-annita') {
      window.location.href = '/products/lipstick-n03-annita';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lipstick-n04-pink-it') {
      window.location.href = '/products/lipstick-n04-pink-it';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lipstick-n05-mama') {
      window.location.href = '/products/lipstick-n05-mama';
  }
  
  if (window.location.pathname === '/collections/all-products/products/lipstick-n06-penny') {
      window.location.href = '/products/lipstick-n06-penny';
  }
  
  if (window.location.pathname === '/collections/all-products/products/may-offer') {
      window.location.href = '/products/may-offer';
  }
  
  if (window.location.pathname === '/collections/all-products/products/ouaou-mascara') {
      window.location.href = '/products/ouaou-mascara';
  }
  
  if (window.location.pathname === '/collections/all-products/products/ouaou-mascara-doro-offer') {
      window.location.href = '/products/ouaou-mascara-doro-offer';
  }
  
  if (window.location.pathname === '/collections/all-products/products/shampoo-new-technology-300ml') {
      window.location.href = '/products/shampoo-new-technology-300ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/silk-skin-foundation-n1-light') {
      window.location.href = '/products/silk-skin-foundation-n1-light';
  }
  
  if (window.location.pathname === '/collections/all-products/products/silk-skin-foundation-n2-medium') {
      window.location.href = '/products/silk-skin-foundation-n2-medium';
  }
  
  if (window.location.pathname === '/collections/all-products/products/silk-skin-foundation-n3-dark') {
      window.location.href = '/products/silk-skin-foundation-n3-dark';
  }
  
  if (window.location.pathname === '/collections/all-products/products/space-vibes-palette-n2') {
      window.location.href = '/products/space-vibes-palette-n2';
  }
  
  if (window.location.pathname === '/collections/all-products/products/sun-glow-shimmering-face-body-lotion-100ml') {
      window.location.href = '/products/sun-glow-shimmering-face-body-lotion-100ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/sun-protection-bi-phase-water-spf30-150ml') {
      window.location.href = '/products/sun-protection-bi-phase-water-spf30-150ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/terra-vibes-palette-n1') {
      window.location.href = '/products/terra-vibes-palette-n1';
  }
  
  if (window.location.pathname === '/collections/all-products/products/tinted-sun-cream-spf30-50ml') {
      window.location.href = '/products/tinted-sun-cream-spf30-50ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/tinted-sun-cream-ouaou-mascara-offer') {
      window.location.href = '/products/tinted-sun-cream-ouaou-mascara-offer';
  }
  
  if (window.location.pathname === '/collections/all-products/products/transparent-loose-powder') {
      window.location.href = '/products/transparent-loose-powder';
  }
  
  if (window.location.pathname === '/collections/all-products/products/vertigo-eau-de-parfum-100ml') {
      window.location.href = '/products/vertigo-eau-de-parfum-100ml';
  }
  
  if (window.location.pathname === '/collections/all-products/products/siskebasia-dorou') {
      window.location.href = '/products/siskebasia-dorou';
  }

  if (window.location.pathname === '/collections/hot-offers/products/ouaou-mascara-doro-offer') {
      window.location.href = '/products/ouaou-mascara-doro-offer';
  }
  
  if (window.location.pathname === '/collections/hot-offers/products/black-diamond-cleanser-doro-ouaou-mascara') {
      window.location.href = '/products/black-diamond-cleanser-doro-ouaou-mascara';
  }
  
  if (window.location.pathname === '/collections/hot-offers/products/tinted-sun-cream-ouaou-mascara-offer') {
      window.location.href = '/products/tinted-sun-cream-ouaou-mascara-offer';
  }
  if (window.location.pathname === '/collections/hot-offers/products/valentines-offer') {
      window.location.href = '/products/valentines-offer';
  }

  if (window.location.pathname === '/collections/hot-offers/products/makeup-65') {
      window.location.href = '/products/makeup-65';
  }

  if (window.location.pathname === '/collections/hot-offers/products/shampoo-new-technology-hair-mask-prosfora-60') {
      window.location.href = '/products/shampoo-new-technology-hair-mask-prosfora-60';
  }

  if (window.location.pathname === '/collections/hot-offers/products/tinted-sun-cream-me-doro-tin-ouaou-mascara') {
      window.location.href = '/products/tinted-sun-cream-me-doro-tin-ouaou-mascara';
  }

  if (window.location.pathname === '/collections/hot-offers/products/lip-volume-me-doro-tin-ouaou-mascara') {
      window.location.href = '/products/tinted-sun-cream-me-doro-tin-ouaou-mascara';
  }

  if (window.location.pathname === '/collections/hot-offers/products/lash-therapy-65') {
      window.location.href = '/products/lash-therapy-65';
  }

  if (window.location.pathname === '/collections/hot-offers/products/eyeshadow-palette-lipstick-20-00-gift-ouaou-mascara') {
      window.location.href = '/products/eyeshadow-palette-lipstick-20-00-gift-ouaou-mascara';
  }

  if (window.location.pathname === '/collections/hot-offers/products/shampoo-hair-mask-instant-spray-hair-oil-25-00') {
      window.location.href = '/products/shampoo-hair-mask-instant-spray-hair-oil-25-00';
  }

  if (window.location.pathname === '/collections/hot-offers/products/poudra-silk-skin-foundation-concealer-40-00-doro-ouaou-mascara') {
      window.location.href = '/products/poudra-silk-skin-foundation-concealer-40-00-doro-ouaou-mascara';
  }
  
  if (window.location.pathname === '/collections/hot-offers/products/silk-set') {
      window.location.href = '/products/silk-set';
  }

  if (window.location.pathname === '/collections/hot-offers/products/silk-skin-foundation-lipstick-01-fire-doro-ouaou-mascara') {
      window.location.href = '/products/silk-skin-foundation-lipstick-01-fire-doro-ouaou-mascara';
  }

  if (window.location.pathname === '/collections/hot-offers/products/limited-edition-women-s-day-set') {
      window.location.href = '/products/limited-edition-women-s-day-set';
  }

  if (window.location.pathname === '/collections/hot-offers/products/mothers-day-special-set') {
      window.location.href = '/products/mothers-day-special-set';
  }
  
  if (window.location.pathname === '/collections/hot-offers/products/sun-glow-lotion-1-1-doro-17-90-mascara-ouaou') {
      window.location.href = '/products/sun-glow-lotion-1-1-doro-17-90-mascara-ouaou';
  }

  if (window.location.pathname === '/product/makeup/maskara-lash-therapy-offer') {
  window.location.href = '/products/lash-therapy-65';
  }

    document.querySelector('.CallBackIcons-PopupButton').addEventListener('click', function(e) {
      e.preventDefault();
      const popup = document.querySelector('.CallBackIcons-PopupContent');
      popup.classList.toggle('active');

      const telephoneIcon = document.querySelector('.telephone-icon');
      const closeIcon = document.querySelector('.close-icon');

      // Toggle icons
      if (popup.classList.contains('active')) {
          telephoneIcon.style.display = 'none';
          closeIcon.style.display = 'block';
      } else {
          telephoneIcon.style.display = 'block';
          closeIcon.style.display = 'none';
      }
  });
})();
